export default {
  SIZE: 'size',
} as const;
